import { HttpClient } from "@angular/common/http";
import { INDRAApiService } from "@ibe.services/api.indra.service";
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
import { finalize } from 'rxjs/operators';
import { URL_ROOT, URL_CREATE_UPDATE_NEW_CONTACT, MOCK_URL_CREATE_NEW_PNR_CONTACT, MOCK_STATUS } from "@ibe.config";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
import * as i3 from "./parallel.indra.service";
var INDRAContactsService = /** @class */ (function () {
    function INDRAContactsService(http, api, parallelService) {
        this.http = http;
        this.api = api;
        this.parallelService = parallelService;
    }
    INDRAContactsService.prototype.INDRA_EditContacts = function (pnr, contact) {
        var URL_PNR_CONTACT_EDIT = URL_ROOT + "booking/pnr/" + pnr + "/contacts/update";
        return this.api.INDRA_put(URL_PNR_CONTACT_EDIT, contact);
    };
    INDRAContactsService.prototype.INDRA_CreateContacts = function (contact) {
        var _this = this;
        if (MOCK_STATUS.NEW_PNR_CONTACT) {
            return this.api.INDRA_get(MOCK_URL_CREATE_NEW_PNR_CONTACT);
        }
        else {
            return this.api.INDRA_put(URL_CREATE_UPDATE_NEW_CONTACT, contact).pipe(finalize(function () {
                _this.parallelService.INDRA_setTriggerCreateContact(false);
                _this.parallelService.INDRA_setIsContactCreated(true);
            }));
        }
    };
    INDRAContactsService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAContactsService_Factory() { return new INDRAContactsService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService), i0.inject(i3.INDRAParallelService)); }, token: INDRAContactsService, providedIn: "root" });
    return INDRAContactsService;
}());
export { INDRAContactsService };
